import React, { useState } from "react";
import { Controller } from "react-hook-form";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { IFormField } from "../../../models/app";

interface Props extends IFormField {
  errors: any;
  control: any;
  required?: boolean;
  defaultValue?: any;
  setValue?: any;
  watch?: any;
}

const RHPhone: React.FC<Props> = ({
  label,
  name,
  type,
  placeholder,
  disabled,
  autoFocus,
  control,
  errors,
  required,
  defaultValue,
  onChange,
  watch,
  hidden,
  endAdornment,
  helperText,
  startAdornment,
  multiline,
  minRows,
  showLabel = true,
  subDefaultValue,
}) => {

  return (
    <Stack spacing={1} width="100%" mt={0}>
      {!hidden && (
        <Stack direction="row" spacing={1} width="100%">
            <Controller
              control={control}
              name={name}
              render={({ field }) => (
                <TextField
                  fullWidth
                  size="small"
                  {...field}
                  defaultValue={defaultValue}
                  required={required}
                  type={type}
                  inputProps={{
                    min: type === "number" ? 0 : undefined,
                    icon: null,
                  }}
                  disabled={disabled}
                  autoFocus={autoFocus}
                  placeholder={placeholder}
                  multiline={multiline || false}
                  minRows={minRows || 1}
                  error={!!errors[name]}
                  InputProps={{
                    endAdornment: endAdornment || undefined,
                    startAdornment: startAdornment || undefined,
                  }}
                  InputLabelProps={{
                    children: label,
                    sx: {
                      fontSize: "18px",
                    
                      "& .MuiInputLabel-asterisk": {
        
                        fontSize: "24px",
                      },
                    },
                  }}
                  label={label}
                  onChange={(e: any) => {
                    onChange &&
                      onChange( e.target.value);
                    field.onChange(e);
                  }}
                  onKeyDown={(e: any) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                    }
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      bgcolor: "common.white",
                    },
                    "& .MuiInputBase-root": {
                      fontFamily: "Cairo",
                      p: "2px",
                      px: "10px",
                      borderRadius: "8px",
                      color: "label.main",
                      border: "none",
                      bgcolor: "#fff",
                      fontSize: "18px",
                      height: "48px",
                    },
                    "& .MuiInputBase-root.Mui-disabled": {
                      bgcolor: "#f5f5f5",
                    },
                    "& .MuiFormLabel-root": {
                      color: !disabled ? "text.main" : "text.disabled",
                    },
                  }}
                />
              )}
            />
          </Stack>
   
      )}
    </Stack>
  );
};

export default RHPhone;
